import { Flex } from "antd";
import { OutstandingClaimsIndicator } from "molecules/PatientSummary/OutstandingClaimsIndicator";
import { UnlinkedIndicator } from "molecules/PatientSummary/UnlinkedIndicator";
import { parsePhone } from "@vyne-shared/utils/phone";
import type { ExistingPatientResult } from "api/responses";

type GuarantorIndicatorProps = Readonly<Pick<ExistingPatientResult, "pmsId" | "isGuarantor">>;

const GuarantorIndicator = ({ pmsId, isGuarantor }: GuarantorIndicatorProps) =>
    pmsId && isGuarantor ? <i>(Guarantor)</i> : null;

/** Display a label for a patient in a menu of search results. */
export const PatientLabel = ({ prp }: { readonly prp: ExistingPatientResult }) => (
    <Flex gap="0.25rem">
        <UnlinkedIndicator unlinked={prp.unlinked} />
        {prp.givenName} {prp.familyName}
        <GuarantorIndicator pmsId={prp.pmsId} isGuarantor={prp.isGuarantor} />
        <OutstandingClaimsIndicator hasOutstandingClaims={prp.hasOutstandingClaims} /> &mdash; {getContact(prp)}
    </Flex>
);

function getContact(prp: ExistingPatientResult) {
    if (prp.phone) {
        const phoneNumber = parsePhone(prp.phone);
        if (phoneNumber) {
            return phoneNumber.formatNational();
        }
        return prp.phone;
    }

    return prp.email ?? "No contact information";
}
